export const CTA = {
  parts: ['Container', 'Intro'],

  baseStyle: {
    Container: {
      padding: '18px 10px',
      background: 'brand.lightgreen2',
      borderRadius: '8px',
      textAlign: 'center',
    },
    Intro: {
      fontSize: '16px',
      padding: '0px 10px 24px 10px',
    },
  },
};
